import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components';
import { ColorEnum } from '@app/common';
import { ValueDescription } from '../../../../../card/value-description/value-description';
import Skeleton from '../../../../skeleton';
import { CardTitle } from '../../../../../card/title/card-title';

export const SkeletonDashboardCardsPortfolioValue: React.FC = observer(() => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <div
            className="relative flex h-full min-h-[37.6rem] flex-col justify-between rounded-large p-[1.6rem] shadow-strong lg:p-[2.2rem]"
            style={{ backgroundColor: theme.assetColor[ColorEnum.Gray].main }}
        >
            <div className="relative inset-0 flex flex-col items-start">
                <CardTitle
                    title={
                        <div className="flex items-center gap-xsmall text-vsmall leading-vsmall font-bold uppercase text-[#fafcff]/60">
                            <div>{t('layout.statisticsCard.portfolioValue.title')}</div>
                        </div>
                    }
                />
                <div className="flex items-center gap-vsmall text-vlarge leading-vlarge font-bold text-neutral-white">
                    <Skeleton width={3} height={3} radius={20} />
                    <Skeleton height={1.6} />
                </div>
            </div>
            <ValueDescription
                value={<Skeleton height={2.4} />}
                description={<Skeleton height={1.3} width={11} />}
                padding={'none'}
                valueColor={'default'}
                descriptionColor={'default'}
            />
        </div>
    );
});
